<template>
    <ui-accordion class="collapsible">
        <div class="collapsible--head"
                :class="updateIsOpenClass('head', props)"
                slot-scope="props"
                slot="head">
            <slot name="head"/>
            <div class="collapsible--icon-wrapper">
                <ui-icon class="collapsible--icon" :symbol="getIcon(props)" size="medium"/>
            </div>
        </div>
        <div class="collapsible--body"
                :class="updateIsOpenClass('body', props)"
                slot-scope="props"
                slot="body">
            <slot name="body"/>
        </div>
    </ui-accordion>
</template>

<script>
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import UiAccordion from '@dreipol/vue-ui/src/components/accordion/accordion';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            UiAccordion,
            UiIcon,
        },
        mixins: [bemMixin('collapsible')],
        props: {},
        methods: {
            getIcon({ isOpen }) {
                return isOpen ? 'collapse' : 'open';
            },
            updateIsOpenClass(blockName, { isOpen }) {
                return this.bemAdd(isOpen ? 'is-open' : 'base', blockName);
            },
        },
    };
</script>
